import AppCopy from "copy/AppCopy";
import React from "react";

function LiveCarStatusHeader() {
  const { carNoText, assignedText, CustomerText, statusText } =
    AppCopy.overview;

  return (
    <div className={Classname.container}>
      <span className={Classname.carNo}>{carNoText}</span>
      <span className={Classname.asigned}>{assignedText}</span>
      <span className={Classname.status}>{statusText}</span>
      <span className={Classname.customer}>{CustomerText}</span>
      <span className={Classname.detail}></span>
    </div>
  );
}

export default LiveCarStatusHeader;

const Classname = {
  container:
    "w-full border-b hidden sm:flex items-center justify-between text-sm text-secondaryText py-2",
  carNo: "w-1/6",
  asigned: "w-1/6",
  status: "w-1/6 flex justify-center",
  customer: "w-1/6 flex justify-end",
  detail: "w-1/6",
};
